import checkCaptcha from "../other/check_captcha.js";
import showErrors from "../errors/showErrors.js";

export default async function () {
    this.loading = true;
    let form_data = new FormData;

    form_data.append('action', ajax_var.action_reset);
    form_data.append('email', this.dataInput.value);
    form_data.append('nonce', ajax_var.nonce);
    form_data.append('re_token', await checkCaptcha());

    try {
        var res = await axios.post(ajax_var.url, form_data);

        if (res.status === 200 && res.data) {
            this.$router.push('/reset/');
        }
    } catch (error) {
        showErrors.call(this, 'send reset link', error);
    }

    this.loading = false;
}
